import { motion } from 'framer-motion';
import WebinarDialog from "@/components/WebinarDialog";
import { useState } from 'react';

const CTASection = () => {
  const [isWebinarDialogOpen, setIsWebinarDialogOpen] = useState(false);

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-black to-black"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20"></div>
      </div>

      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <div className="inline-block px-4 py-1 bg-green-900/30 text-green-400 text-sm font-medium rounded-full border border-green-500/30 mb-6">
            Limited Seats Available
          </div>
          
          <h2 className="text-4xl md:text-4xl font-bold mb-6">
            Ready to Witness History with <span className="text-green-400">CORAA AI</span>?
          </h2>
          
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
            Join us for a live demonstration of CORAA in action. See how you can save hundreds of hours 
            while increasing your social impact.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <motion.a
              onClick={() => setIsWebinarDialogOpen(true)}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="px-8 py-5 bg-gradient-to-r from-green-500 to-green-600 text-white text-lg font-semibold rounded-xl shadow-lg hover:shadow-green-500/30 transition-all flex items-center justify-center gap-2"
            >
              <span></span> Reserve Your Spot Now   
            </motion.a>

          </div>

          {/* Countdown Timer */}
          


        </motion.div>
      </div>

      {/* Floating elements */}
      <motion.div 
        className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent -z-10"
      />
      <motion.div 
        className="absolute top-1/3 left-1/4 w-64 h-64 bg-green-500/10 rounded-full filter blur-3xl -z-20"
        animate={{
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      {isWebinarDialogOpen && (
        <WebinarDialog
          isOpen={isWebinarDialogOpen}
          onClose={() => setIsWebinarDialogOpen(false)}
        />
      )}
    </section>
  );
};

export default CTASection;
